
const Spinner = () => {
    return (
        <div className="h-[60vh] w-full flex justify-center items-center">
            <div className="inline-block w-[50px] h-[50px] border-4 border-solid border-slate-300 rounded-full border-t-[#636767] animate-spin"/>
        </div>
    )
}

export default Spinner